<template>
  <div :class="b(mods)">
    <div :class="b('options')">
      <div
        v-for="(option, index) in optionsVisible"
        :key="index"
        :class="b(`option`)"
      >
        <ga-image-responsive
          v-if="postRendered"
          :class="b(`option-picture`)"
          :image="option"
          :class-name="b('option-img')"
        />
      </div>
    </div>

    <div v-if="extraCount > 0 && options.length > 1" :class="b('count')">
      +{{ extraCount }}
    </div>
  </div>
</template>

<script src="./colors.scripts.js" />

<style module src="./colors.styles.scss" lang="scss" />
